

/* REDESIGN GRID */

function redesignGridx() {
    console.log('redesignGridx');
  

    
    var dimensioneGriglia = (jQuery('.grid-container').width()) / 5;

    /*if (jQuery('.grid-container').width() >= 546) {

        jQuery('.grid-container').css('grid-auto-rows', dimensioneGriglia);
    } else {
        jQuery('.grid-container').css('grid-auto-rows', dimensioneGriglia);
    }*/
     ///jQuery('.grid-container').css('grid-auto-rows', dimensioneGriglia);

}


jQuery(document).ready(function() {

   //redesignGridx();

    window.onresize = function(event) {
        //redesignGridx();
    };

/* FINE REDESIGN GRID */





/* MOVIMENTO ELEMENTI AL CARICAMENTO IN HP */

    jQuery('.grid-item img').each(function() {
        var delayc = anime.random(1000, 2000);

        if (this.complete) {
            //console.log('complete' + this.id);

            anime({
                targets: this,
                opacity: 1,
                duration: 500,
                easing: 'easeOutSine',
                delay: delayc,
                complete: function(anim) {
                    //console.log('opacity:' + delayc);
                },
            });

            anime({
                targets: this,
                marginTop: '0px',
                duration: 500,
                delay: delayc,

                easing: 'easeOutSine',

                complete: function(anim) {
                    //console.log('translate:' + delayc);
                },
            });




        } else {
            jQuery(this).on('load', function(e) {
                anime({
                    targets: this,
                    opacity: 1,
                    duration: 500,
                    easing: 'easeOutSine',
                    delay: delayc,
                    complete: function(anim) {
                        //console.log('opacity:' + delayc);
                    },
                });

                anime({
                    targets: this,
                    marginTop: '0px',
                    duration: 500,
                    delay: delayc,

                    easing: 'easeOutSine',

                    complete: function(anim) {
                        //console.log('translate:'+delayc);               
                    },
                });
            });
        }

    });
    /* FINE MOVIMENTO ELEMENTI AL CARICAMENTO IN HP */
});






jQuery(document).ready(function() {

    /*  ANIMAZIONE BLOCCHI HP ALL'HOVER */


    var avanti = anime({
        targets: '#img-ej1',
        duration: 700,
        scale: 1.1,
        easing: 'easeOutQuad',
        autoplay: false,
        complete: function(anim) {}
    });
   avanti.reverse();
    jQuery('.ej1').hover(function() {
        avanti.reverse();
        avanti.play();
    }, function() {
        avanti.reverse();
        avanti.play();
    });


    var avantiej4 = anime({
        targets: '#img-ej4',
        duration: 700,
        scale: 1.1,
        /*rotate: '0.01turn',*/
        easing: 'easeOutQuad',
        autoplay: false,
        complete: function(anim) {}
    });
    avantiej4.reverse();

    jQuery('.ej4').hover(function() {
        
        avantiej4.reverse();
        
        avantiej4.play();
    }, function() {

        avantiej4.reverse();
        avantiej4.play();

    });
    /*  FINE ANIMAZIONE BLOCCHI HP ALL'HOVER */


    var avantiej4lib = anime({
        targets: '#img-ej4_library',
        duration: 700,
        scale: 1.1,
        /*rotate: '0.01turn',*/
        easing: 'easeOutQuad',
        autoplay: false,
        complete: function(anim) {}
    });
    avantiej4lib.reverse();

    jQuery('.ej4_library').hover(function() {
        
        avantiej4lib.reverse();        
        avantiej4lib.play();
    }, function() {

        avantiej4lib.reverse();
        avantiej4lib.play();

    });



});


